import {
    Button,
    CloseButton,
    Container,
    Dialog,
    Grid,
    GridItem,
    Image,
    Stack,
    Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

const ButtonSocial = ({ children, icon, onclick, isDisabled }) => {
    return (
        <Button
            fontSize="md"
            placeSelf="center"
            bg="white"
            borderRadius="md"
            borderWidth={1}
            borderStyle="solid"
            borderColor="gray.200"
            _hover={{
                background: "#F0F0F0",
                cursor: "pointer",
            }}
            _dark={{ borderColor: "gray.700" }}
            textAlign="center"
            py={2}
            h={12}
            w="100%"
            px={4}
            onClick={onclick}
            disabled={isDisabled}
        >
            <Stack
                direction="row"
                align="center"
                placeSelf="center"
                textAlign="start"
                mr="auto"
                py={0}
                px={0}
            >
                <Image boxSize="20px" objectFit="cover" src={icon} alt={children} loading="lazy" />
                <Text
                    fontWeight="400"
                    fontSize={{ base: "xs", md: "sm" }}
                    mb={2}
                    color="black"
                    textAlign="end"
                >
                    {children}
                </Text>
            </Stack>
        </Button>
    );
};

const ButtonCompartir = ({ children, icon, url, fontsize }) => {
    const [screenSize, getDimension] = useState({
        winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
        winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
    });

    const setDimensions = () => {
        getDimension({
            winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
            winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
        });
    };

    useEffect(() => {
        window.addEventListener("resize", setDimensions);

        return () => {
            window.removeEventListener("resize", setDimensions);
        };
    }, [screenSize]);

    const [isOpen, setIsOpen] = useState(false);

    const onOpen = () => setIsOpen(true);
    const onClose = () => setIsOpen(false);

    const [copyText, setCopyText] = useState("Copiar enlace");
    const urlShareWhatsApp = `https://api.whatsapp.com/send?text=Esta propiedad es increíble... ${url}`;
    const urlShareTwitter = `https://twitter.com/intent/tweet?text=Esta propiedad es increíble...&url="${url}`;
    const urlShareFacebook = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    const urlShareMessenger = `fb-messenger://share?link=${url}`;
    const urlShareEmail = `mailto:?subject=Esta propiedad es increíble...&body=Esta propiedad es increíble... ${url}`;
    const urlShaereMessage = `sms:?body=Esta propiedad es increíble... ${url}`;

    const handleCopy = (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(url);
        setCopyText("Enlace copiado");
        setInterval(() => {
            setCopyText("Copiar enlace");
        }, 3000);
    };

    const handleShare = (e, urlShare) => {
        e.preventDefault();
        window.open(urlShare, "_blank");
    };

    return (
        <Stack onClick={onOpen} p={2}>
            <Stack
                direction="row"
                align="flex-end"
                placeSelf="end"
                float="right"
                alignItems="center"
                fontSize={fontsize}
            >
                <Image boxSize="17px" objectFit="cover" src={icon} alt={children} loading="lazy" />
                <Text fontWeight="400" fontSize={fontsize} color="black" textAlign="end">
                    {children}
                </Text>
            </Stack>
            <Dialog.Root
                placement="center"
                open={isOpen}
                onOpenChange={() => onClose()}
                preventScroll
                size="sm"
            >
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content bg="#f8f8f8" p={10} cursor="initial">
                        <Dialog.Header />
                        <Dialog.CloseTrigger asChild>
                            <CloseButton
                                size="sm"
                                borderRadius="md"
                                _hover={{ background: "#F0F0F0", cursor: "pointer" }}
                            />
                        </Dialog.CloseTrigger>
                        <Dialog.Body>
                            <Stack direction="row">
                                <Container alignSelf="center">
                                    <Text fontWeight="600" fontSize="md" mb={2}>
                                        Comparte esta propiedad con tus amigos y familiares
                                    </Text>
                                </Container>
                            </Stack>
                            <Stack direction="row" mt={6}>
                                <Container alignSelf="center">
                                    <Grid templateColumns="repeat(2, 1fr)" gap={2}>
                                        <GridItem colSpan={1}>
                                            <ButtonSocial
                                                icon="https://media.grupoguia.mx/assets/home-page/fichas/Compartir/copia-clipboard.webp"
                                                onclick={(e) => handleCopy(e)}
                                            >
                                                {copyText}
                                            </ButtonSocial>
                                        </GridItem>
                                        <GridItem colSpan={1}>
                                            <ButtonSocial
                                                icon="https://media.grupoguia.mx/assets/home-page/fichas/Compartir/email.webp"
                                                onclick={(e) => handleShare(e, urlShareEmail)}
                                            >
                                                Email
                                            </ButtonSocial>
                                        </GridItem>
                                        <GridItem colSpan={1}>
                                            <ButtonSocial
                                                icon="https://media.grupoguia.mx/assets/home-page/fichas/Compartir/mensajes.webp"
                                                onclick={(e) => handleShare(e, urlShaereMessage)}
                                            >
                                                Mensajes
                                            </ButtonSocial>
                                        </GridItem>
                                        <GridItem colSpan={1}>
                                            <ButtonSocial
                                                icon="https://media.grupoguia.mx/assets/home-page/fichas/Compartir/whatsapp.webp"
                                                onclick={(e) => handleShare(e, urlShareWhatsApp)}
                                            >
                                                WhatsApp
                                            </ButtonSocial>
                                        </GridItem>
                                        {screenSize.winWidth < 768 ? (
                                            <GridItem colSpan={1}>
                                                <ButtonSocial
                                                    icon="https://media.grupoguia.mx/assets/home-page/fichas/Compartir/mensajero.webp"
                                                    onclick={(e) =>
                                                        handleShare(e, urlShareMessenger)
                                                    }
                                                >
                                                    Messenger
                                                </ButtonSocial>
                                            </GridItem>
                                        ) : null}

                                        <GridItem colSpan={1}>
                                            <ButtonSocial
                                                icon="https://media.grupoguia.mx/assets/home-page/fichas/Compartir/facebook.webp"
                                                onclick={(e) => handleShare(e, urlShareFacebook)}
                                            >
                                                Facebook
                                            </ButtonSocial>
                                        </GridItem>
                                        <GridItem colSpan={1}>
                                            <ButtonSocial
                                                icon="https://media.grupoguia.mx/assets/home-page/fichas/Compartir/gorjeo.webp"
                                                onclick={(e) => handleShare(e, urlShareTwitter)}
                                            >
                                                Twitter
                                            </ButtonSocial>
                                        </GridItem>
                                    </Grid>
                                </Container>
                            </Stack>
                        </Dialog.Body>
                        <Dialog.Footer />
                    </Dialog.Content>
                </Dialog.Positioner>
            </Dialog.Root>
        </Stack>
    );
};

export default ButtonCompartir;
